import {
  Box,
  Card,
  CardContent,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  ListSubheader,
  MenuItem,
  Button as MuiButton,
  Paper,
  Select,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { useFormAccordo } from "./ContextAccordo";
import { Delete } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { useTheme } from "@mui/system";
import { NumericFormat } from "react-number-format";
import ConfermaElimina from "./lib/ConfermaElimina";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)});
`;

const Button = styled(MuiButton)`
  margin: 0 8px;
`;

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

/* 
  Categorie: value 
  Operazioni: idOperazione && value
  Filtri: idTipologia === idOperazione && idCategoria === value in Categorie && value
  dataset: idFiltro === value in Filtri && idTipologia === value in Operazioni
*/

const Condizioni = () => {
  const { formState, dispatch } = useFormAccordo();
  const filtri = formState.condizioni?.filtri;
  const categorie = formState.condizioni?.categorie;
  const operazioni = formState.condizioni?.operazioni;
  const parametri = formState.condizioni?.filtri.filter(
    (el) => el.parametri.length
  );
  const fasce = formState.condizioni?.dataset;

  const provenienza = formState.accordo?.provenienza.value;
  const provenienzaDataset = formState.accordo?.provenienza.dataset;
  const provenienzaLabel = provenienzaDataset?.find(
    (el) => el.value === provenienza
  )?.label;
  const provenienzaValori =
    formState.provenienzaValori?.[provenienzaLabel?.toLowerCase()];

  const [subTable, setSubTable] = useState();
  const [valueTabs, setValueTabs] = useState(0);
  const [rows, setRows] = useState(fasce);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [fasciaToDelete, setFasciaToDelete] = useState(null);

  const theme = useTheme();
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        backgroundColor: theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
      },
    },
  };

  const handleClick = (i) => {
    if (i === 0) {
      setSubTable(0);
    }
    if (subTable === i) {
      setSubTable("");
    } else {
      setSubTable(i);
    }
  };

  const handleAggiungiCondizione = (fascia) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.idFascia === 0 && fascia === 0 // Check if it's the 'base' fascia
          ? {
              ...row,
              operazioni: [
                ...row.operazioni,
                {
                  id: row.operazioni.length + 1,
                  isNew: 1,
                  idFascia: 0,
                  parametro1: "",
                  idFiltro: 1,
                  idTipologia: 1,
                  condizione: "Nuova condizione",
                },
              ],
            }
          : row.idFascia === fascia // Handle other fasce
          ? {
              ...row,
              operazioni: [
                ...row.operazioni,
                {
                  id: row.operazioni.length + 1, // Incremental ID
                  isNew: 1,
                  idFascia: fascia,
                  parametro1: "",
                  idFiltro: 1,
                  idTipologia: 1,
                  condizione: "Nuova condizione",
                },
              ],
            }
          : row
      )
    );
  };

  const handleAggiungiFascia = () => {
    setRows((prevRows) => [
      ...prevRows,
      {
        idFascia: prevRows.length, // Incremental fascia number
        operazioni: [],
        provenienzaIdValore: "",
        tipoSconto: 1,
        sconto: null,
        isNew: 1,
      },
    ]);
  };

  const handleDelete = (type, index, subIndex = null) => {
    setRows((prevRows) => {
      if (type === "fascia") {
        // Delete the entire fascia
        return prevRows
          .filter((_, i) => index !== 0 && i !== index) // Remove the selected fascia
          .map((row, i) => ({
            ...row,
            fascia: row.idFascia === 0 ? 0 : i, // Keep 'base' unchanged, reassign others
          }));
      } else if (type === "condizione" && subIndex !== null) {
        // Only delete from the matching fascia
        return prevRows.map((row) =>
          row.idFascia === index
            ? {
                ...row,
                operazioni: row.operazioni
                  .filter((_, j) => j !== subIndex)
                  .map((condizione, i) => ({
                    ...condizione,
                    id: i + 1, // Reassign IDs
                  })),
              }
            : row
        );
      }
      return prevRows;
    });
  };

  // Callback for dialog confirmation
  const handleConfirmDelete = () => {
    if (fasciaToDelete !== null) {
      handleDelete("fascia", fasciaToDelete);
      setOpenDeleteDialog(false);
      setFasciaToDelete(null);
    }
  };

  useEffect(() => {
    console.log(rows);
    dispatch({
      type: "set_condizioni", // Replace with the appropriate action type
      payload: rows, // Pass the updated rows
    });
  }, [rows, dispatch]);

  useEffect(() => {
    // Assign fascia display order if missing
    setRows((prevRows) =>
      prevRows.map((row, i) =>
        row.idFascia === 0 ? { ...row, fascia: 0 } : { ...row, fascia: i }
      )
    );
  }, []);

  return (
    <>
      <ConfermaElimina
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        onConfirm={handleConfirmDelete}
      />
      <Box textAlign="end">
        <Button variant="contained" onClick={handleAggiungiFascia}>
          Nuova Fascia
        </Button>
      </Box>
      <Paper sx={{ mt: "0.5" }}>
        <TableWrapper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="left" colSpan={1}>
                  Fascia
                </TableCell>
                <TableCell align="center" colSpan={4}>
                  Impostazioni
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((fascia) => (
                <Fragment key={fascia.idFascia}>
                  <TableRow
                    sx={
                      fascia.idFascia === 0
                        ? {
                            backgroundColor:
                              theme.palette.mode === "dark"
                                ? "#1B2635"
                                : "#F7F9FC",
                          }
                        : {}
                    }
                  >
                    <TableCell>
                      <IconButton
                        sx={{ mr: 4 }}
                        aria-label="expand row"
                        size="small"
                        onClick={() => handleClick(fascia.idFascia)}
                      >
                        {subTable === fascia.idFascia ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontWeight: "bold" }}>
                        {fascia.idFascia === 0 ? "Base" : fascia.fascia}
                      </span>
                    </TableCell>
                    <TableCell align="center">
                      {fascia.idFascia !== 0 && (
                        <>
                          <FormControl
                            size="small"
                            margin="none"
                            sx={{ minWidth: 200 }}
                          >
                            <InputLabel id="provenienza-label">
                              Provenienza
                            </InputLabel>
                            <Select
                              labelId="provenienza-label"
                              id={`Provenienza/${fascia.idFascia}`}
                              name={`Provenienza/${fascia.idFascia}`}
                              label="Provenienza"
                              value={fascia.provenienzaIdValore}
                              MenuProps={MenuProps}
                              onChange={(e) =>
                                setRows((prevRows) =>
                                  prevRows.map((row) =>
                                    row.idFascia === fascia.idFascia
                                      ? {
                                          ...row,
                                          provenienzaIdValore: e.target.value,
                                        } // Toggle the bersani property
                                      : row
                                  )
                                )
                              }
                            >
                              {provenienzaValori?.map((el) => (
                                <MenuItem key={el.ID} value={el.ID}>
                                  {el.Valore}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </>
                      )}
                    </TableCell>
                    <TableCell align="left">
                      <Box display="flex" justifyContent="center">
                        {fascia.idFascia !== 0 && (
                          <>
                            <FormControl size="small" margin="none">
                              <InputLabel id="tipoSC-label">
                                Tipo SC.
                              </InputLabel>
                              <Select
                                labelId="tipoSC-label"
                                id={`TipoSC/${fascia.idFascia}`}
                                name={`TipoSC/${fascia.idFascia}`}
                                label="Tipo SC."
                                value={fascia.tipoSconto}
                                MenuProps={MenuProps}
                                onChange={(e) =>
                                  setRows((prevRows) =>
                                    prevRows.map((row) =>
                                      row.idFascia === fascia.idFascia
                                        ? { ...row, tipoSconto: e.target.value } // Toggle the bersani property
                                        : row
                                    )
                                  )
                                }
                              >
                                {[
                                  { el: "%", id: 1 },
                                  { el: "€", id: 2 },
                                ].map((el) => (
                                  <MenuItem key={el.id} value={el.id}>
                                    {el.el}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        )}
                        {fascia.idFascia !== 0 && (
                          <>
                            <NumericFormat
                              customInput={TextField}
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={2}
                              label="Sconto"
                              sx={{ width: 100 }}
                              id={`Sconto/${fascia.idFascia}`}
                              name={`Sconto/${fascia.idFascia}`}
                              valueIsNumericString
                              value={fascia.sconto}
                              onValueChange={(e) =>
                                setRows((prevRows) =>
                                  prevRows.map((row) =>
                                    row.idFascia === fascia.idFascia
                                      ? { ...row, sconto: e.value } // Toggle the bersani property
                                      : row
                                  )
                                )
                              }
                            />
                          </>
                        )}
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      {fascia.idFascia !== 0 && (
                        <Tooltip title="Elimina Fascia">
                          <Button
                            variant="contained"
                            onClick={() => {
                              setFasciaToDelete(fascia.fascia);
                              setOpenDeleteDialog(true);
                            }}
                          >
                            <Delete />
                          </Button>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                  {/* SubTable Fasce */}
                  <TableRow
                    sx={{
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
                    }}
                  >
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={8}
                    >
                      <Collapse
                        in={subTable === fascia.idFascia}
                        timeout="auto"
                        unmountOnExit
                        sx={{ mb: 2 }}
                      >
                        <Tabs
                          value={valueTabs}
                          onChange={(e, newValue) => setValueTabs(newValue)}
                          sx={{ marginTop: "4px" }}
                        >
                          <Tab label="Condizioni" />
                        </Tabs>
                        <Card>
                          <CardContent>
                            <CustomTabPanel value={valueTabs} index={0}>
                              <Box
                                sx={{
                                  margin: 1,
                                }}
                              >
                                <Box
                                  marginBottom={2}
                                  display="flex"
                                  justifyContent="end"
                                >
                                  <Button
                                    variant="outlined"
                                    onClick={() =>
                                      handleAggiungiCondizione(subTable)
                                    }
                                  >
                                    Nuova Condizione
                                  </Button>
                                </Box>
                                <Table size="small" aria-label="purchases">
                                  <TableBody>
                                    {fascia.operazioni.map((condizione, j) => (
                                      <TableRow key={condizione.id}>
                                        <TableCell>
                                          <FormControl
                                            size="small"
                                            fullWidth
                                            margin="none"
                                          >
                                            <InputLabel id="filtro-label">
                                              Condizione
                                            </InputLabel>

                                            <Select
                                              labelId="filtro-label"
                                              id={`filtro/${condizione.id}`}
                                              name={`filtro/${condizione.id}`}
                                              label="Condizione"
                                              fullWidth
                                              value={condizione.idFiltro}
                                              MenuProps={MenuProps}
                                              onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRows((prevRows) =>
                                                  prevRows.map((row) =>
                                                    row.idFascia ===
                                                    fascia.idFascia
                                                      ? {
                                                          ...row,
                                                          operazioni:
                                                            row.operazioni.map(
                                                              (cond, index) =>
                                                                index === j
                                                                  ? {
                                                                      ...cond,
                                                                      idFiltro:
                                                                        newValue,
                                                                      idTipologia:
                                                                        "",
                                                                      parametro1:
                                                                        "",
                                                                    }
                                                                  : cond
                                                            ),
                                                        }
                                                      : row
                                                  )
                                                );
                                              }}
                                            >
                                              {categorie.map((categoria) => [
                                                <ListSubheader
                                                  sx={{
                                                    backgroundColor:
                                                      theme.palette.mode ===
                                                      "dark"
                                                        ? "#1B2635"
                                                        : "#F7F9FC",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  {categoria.label}
                                                </ListSubheader>,
                                                filtri
                                                  .filter(
                                                    (filtro) =>
                                                      filtro.idCategoria ===
                                                      categoria.value
                                                  )
                                                  .map((filtro) => (
                                                    <MenuItem
                                                      sx={{
                                                        backgroundColor:
                                                          theme.palette.mode ===
                                                          "dark"
                                                            ? "#1B2635"
                                                            : "#F7F9FC",
                                                      }}
                                                      key={filtro.value}
                                                      value={filtro.value}
                                                    >
                                                      {filtro.label}
                                                    </MenuItem>
                                                  )),
                                              ])}
                                            </Select>
                                          </FormControl>
                                        </TableCell>
                                        {condizione.idFiltro === 8 ? (
                                          <TableCell>
                                            <FormControl
                                              size="small"
                                              fullWidth
                                              margin="none"
                                            >
                                              <InputLabel id="parametri-label">
                                                Parametri
                                              </InputLabel>
                                              <Select
                                                labelId="parametri-label"
                                                id={`parametri/${condizione.id}`}
                                                name={`parametri/${condizione.id}`}
                                                label="Condizione"
                                                fullWidth
                                                value={condizione.parametro1}
                                                MenuProps={MenuProps}
                                                sx={{
                                                  "&& .Mui-selected": {
                                                    backgroundColor: "pink",
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  const newValue =
                                                    e.target.value;
                                                  setRows((prevRows) =>
                                                    prevRows.map((row) =>
                                                      row.idFascia ===
                                                      fascia.idFascia
                                                        ? {
                                                            ...row,
                                                            operazioni:
                                                              row.operazioni.map(
                                                                (cond, index) =>
                                                                  index === j
                                                                    ? {
                                                                        ...cond,
                                                                        parametro1:
                                                                          newValue,
                                                                      }
                                                                    : cond
                                                              ),
                                                          }
                                                        : row
                                                    )
                                                  );
                                                }}
                                              >
                                                {parametri[0].parametri.map(
                                                  (parametro) => (
                                                    <MenuItem
                                                      key={parametro.value}
                                                      value={parametro.value}
                                                    >
                                                      {parametro.label}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </Select>
                                            </FormControl>
                                          </TableCell>
                                        ) : (
                                          <TableCell></TableCell>
                                        )}
                                        <TableCell>
                                          <FormControl
                                            size="small"
                                            fullWidth
                                            margin="none"
                                          >
                                            <InputLabel id="operazioni-label">
                                              Operazioni
                                            </InputLabel>
                                            <Select
                                              labelId="operazioni-label"
                                              id={`operazione/${condizione.id}`}
                                              name={`operazione/${condizione.id}`}
                                              label="Operazioni"
                                              fullWidth
                                              value={condizione.idTipologia}
                                              MenuProps={MenuProps}
                                              onChange={(e) => {
                                                const newValue = e.target.value;
                                                const selectedOperazione =
                                                  operazioni.find(
                                                    (operazione) =>
                                                      operazione.value ===
                                                      newValue
                                                  );
                                                setRows((prevRows) =>
                                                  prevRows.map((row) =>
                                                    row.idFascia ===
                                                    fascia.idFascia
                                                      ? {
                                                          ...row,
                                                          operazioni:
                                                            row.operazioni.map(
                                                              (cond, index) =>
                                                                index === j
                                                                  ? {
                                                                      ...cond,
                                                                      idTipologia:
                                                                        selectedOperazione.value,
                                                                    }
                                                                  : cond
                                                            ),
                                                        }
                                                      : row
                                                  )
                                                );
                                              }}
                                            >
                                              {operazioni
                                                .filter(
                                                  (operazione) =>
                                                    operazione.idOperazione ===
                                                    filtri.find(
                                                      (filtro) =>
                                                        filtro.value ===
                                                        condizione.idFiltro
                                                    )?.idTipologia
                                                )
                                                .map((operazione) => (
                                                  <MenuItem
                                                    key={operazione.value}
                                                    value={operazione.value}
                                                  >
                                                    {operazione.label}
                                                  </MenuItem>
                                                ))}
                                            </Select>
                                          </FormControl>
                                        </TableCell>
                                        <TableCell>
                                          {operazioni.find(
                                            (operazione) =>
                                              operazione.value ===
                                              condizione.idTipologia
                                          )?.idOperazione === 1 ? (
                                            <TextField
                                              size="small"
                                              margin="none"
                                              required
                                              value={condizione.condizione}
                                              id={`condizione/${j}`}
                                              fullWidth
                                              onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRows((prevRows) =>
                                                  prevRows.map((row) =>
                                                    row.idFascia ===
                                                    fascia.idFascia
                                                      ? {
                                                          ...row,
                                                          operazioni:
                                                            row.operazioni.map(
                                                              (cond, index) =>
                                                                index === j
                                                                  ? {
                                                                      ...cond,
                                                                      condizione:
                                                                        newValue,
                                                                    }
                                                                  : cond
                                                            ),
                                                        }
                                                      : row
                                                  )
                                                );
                                              }}
                                              /* error={state.errorNumeroPolizza} */
                                            />
                                          ) : (
                                            <NumericFormat
                                              customInput={TextField}
                                              thousandSeparator="."
                                              fullWidth
                                              decimalSeparator=","
                                              id={`condizione/${j}`}
                                              name={`condizione/${j}`}
                                              valueIsNumericString
                                              value={condizione.condizione}
                                              onValueChange={(e) => {
                                                const newValue = e.value;
                                                setRows((prevRows) =>
                                                  prevRows.map((row) =>
                                                    row.idFascia ===
                                                    fascia.idFascia
                                                      ? {
                                                          ...row,
                                                          operazioni:
                                                            row.operazioni.map(
                                                              (cond, index) =>
                                                                index === j
                                                                  ? {
                                                                      ...cond,
                                                                      condizione:
                                                                        newValue,
                                                                    }
                                                                  : cond
                                                            ),
                                                        }
                                                      : row
                                                  )
                                                );
                                              }}
                                            />
                                          )}
                                        </TableCell>
                                        <TableCell align="center">
                                          <Tooltip title="Elimina Condizione">
                                            <Button
                                              variant="outlined"
                                              onClick={() =>
                                                handleDelete(
                                                  "condizione",
                                                  fascia.idFascia,
                                                  j
                                                )
                                              }
                                            >
                                              <Delete />
                                            </Button>
                                          </Tooltip>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </CustomTabPanel>
                          </CardContent>
                        </Card>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
      </Paper>
    </>
  );
};
export default Condizioni;
